import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOperationsHistory } from '../../../Redux/Actions/actions';
import { FaHistory, FaFilter } from 'react-icons/fa';
import { RENTAL_TYPE } from '../utils/rentalTypeHelpers';
import AuditLogTimeline from '../../../Components/AuditLogTimeline/AuditLogTimeline';
import style from './OperationsHistory.module.css';

const ACTION_OPTIONS = [
  { v: '', l: 'Todas las acciones' },
  { v: 'create', l: 'Creación' },
  { v: 'update', l: 'Actualización' },
  { v: 'cancel', l: 'Cancelación' },
  { v: 'reactivate', l: 'Reactivación' },
  { v: 'adjustment', l: 'Ajuste' },
  { v: 'adjustment_notified', l: 'Ajuste notificado' },
  { v: 'payment_register', l: 'Pago registrado' },
  { v: 'payment_schedule', l: 'Cronograma' },
  { v: 'payment_overdue_run', l: 'Actualización de mora' },
  { v: 'tenant_add', l: 'Inquilino agregado' },
  { v: 'tenant_update', l: 'Inquilino actualizado' },
  { v: 'tenant_delete', l: 'Inquilino eliminado' },
  { v: 'renew', l: 'Renovación' },
  { v: 'contract_signed', l: 'Contrato firmado' },
];

const PAGE_SIZE = 100;

const OperationsHistory = () => {
  const dispatch = useDispatch();
  const operationsHistory = useSelector((state) => state.operationsHistory) || {
    data: [],
    summary: { byAction: [] },
    pagination: null,
  };
  const auditLoading = useSelector((state) => state.auditLoading);

  const [rentalType, setRentalType] = useState(RENTAL_TYPE.REGULAR);
  const [filters, setFilters] = useState({ action: '', from: '', to: '' });

  const load = () => {
    dispatch(
      fetchOperationsHistory(
        { ...filters, limit: PAGE_SIZE, offset: 0 },
        rentalType
      )
    ).catch(() => {});
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rentalType]);

  const byAction = operationsHistory.summary?.byAction || [];
  const total = operationsHistory.pagination?.total ?? operationsHistory.data.length;

  const actionLabel = useMemo(() => {
    const map = {};
    ACTION_OPTIONS.forEach((o) => {
      if (o.v) map[o.v] = o.l;
    });
    return map;
  }, []);

  return (
    <div className={style.container}>
      <div className={style.header}>
        <h1 className={style.title}>
          <FaHistory className={style.titleIcon} />
          Historial de Operaciones
        </h1>
        <p className={style.subtitle}>
          Bitácora global de todas las operaciones realizadas sobre los contratos.
        </p>
      </div>

      <div className={style.typeTabs}>
        {[
          { v: RENTAL_TYPE.REGULAR, l: 'Alquileres completos' },
          { v: RENTAL_TYPE.ADMIN, l: 'Solo administración' },
        ].map((opt) => (
          <button
            key={opt.v}
            type="button"
            className={`${style.typeTab} ${rentalType === opt.v ? style.typeTabActive : ''}`}
            onClick={() => setRentalType(opt.v)}
          >
            {opt.l}
          </button>
        ))}
      </div>

      <div className={style.filters}>
        <div className={style.filterField}>
          <label><FaFilter /> Acción</label>
          <select
            value={filters.action}
            onChange={(e) => setFilters((f) => ({ ...f, action: e.target.value }))}
          >
            {ACTION_OPTIONS.map((o) => (
              <option key={o.v || 'all'} value={o.v}>{o.l}</option>
            ))}
          </select>
        </div>
        <div className={style.filterField}>
          <label>Desde</label>
          <input
            type="date"
            value={filters.from}
            onChange={(e) => setFilters((f) => ({ ...f, from: e.target.value }))}
          />
        </div>
        <div className={style.filterField}>
          <label>Hasta</label>
          <input
            type="date"
            value={filters.to}
            onChange={(e) => setFilters((f) => ({ ...f, to: e.target.value }))}
          />
        </div>
        <button type="button" className={style.applyBtn} onClick={load}>
          Aplicar
        </button>
      </div>

      {byAction.length > 0 && (
        <div className={style.chips}>
          <span className={style.chipTotal}>Total: {total}</span>
          {byAction.map((a) => (
            <span key={a.action} className={style.chip}>
              {actionLabel[a.action] || a.action}: <strong>{a.count}</strong>
            </span>
          ))}
        </div>
      )}

      <div className={style.timelineWrap}>
        <AuditLogTimeline
          logs={operationsHistory.data}
          loading={auditLoading && operationsHistory.data.length === 0}
          emptyText="No hay operaciones para los filtros seleccionados."
          showContract
        />
      </div>
    </div>
  );
};

export default OperationsHistory;
